import React, { useCallback, useEffect, useState } from "react";
import PageTableHeader from "../../../components/pageTableHeader/pageTableHeader";
import CommonTable from "../../../components/table/table";
import DefaultButton from "../../../components/buttons/defaultButton";
import toast from "react-hot-toast";
import {
  deleteScheduledReport,
  getScheduledReports,
} from "../../../../services/workspace/reports.service";

const breadcrumbs = [
  { label: "Reports", path: "/reports" },
  { label: "Schedule Reports", path: "" },
];

const formatDateTime = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const pickId = (item) => item?.id || item?.uuid || item?.schedule_id;

const SchedulePage = () => {
  const [loading, setLoading] = useState(true);
  const [deletingId, setDeletingId] = useState(null);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const fetchSchedules = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getScheduledReports();
      const list = response?.data?.data || response?.data || [];
      setData(Array.isArray(list) ? list : []);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to load scheduled reports");
      setData([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSchedules();
  }, [fetchSchedules]);

  const handleDelete = async (item) => {
    const id = pickId(item);
    if (!id) {
      toast.error("Invalid schedule entry");
      return;
    }
    try {
      setDeletingId(id);
      await deleteScheduledReport(id);
      toast.success("Schedule deleted");
      fetchSchedules();
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to delete schedule");
    } finally {
      setDeletingId(null);
    }
  };

  const tableHeaders = [
    { label: "Report", key: "report" },
    { label: "Frequency", key: "frequency" },
    { label: "Recipients", key: "recipients" },
    { label: "Next Run", key: "next_run" },
    { label: "Status", key: "status" },
    { label: "Actions", key: "actions" },
  ];

  const tableData = data.map((item) => {
    const id = pickId(item);
    const recipients = item?.recipients;

    return {
      id,
      report: {
        data: item?.report_name || item?.report || item?.module || "-",
        variant: "text",
      },
      frequency: {
        data: String(item?.frequency || item?.schedule_type || "-")
          .replaceAll("_", " ")
          .toUpperCase(),
        variant: "text",
      },
      recipients: {
        data: Array.isArray(recipients)
          ? recipients.join(", ")
          : recipients || item?.emails || "-",
        variant: "text",
      },
      next_run: {
        data: formatDateTime(item?.next_run || item?.next_run_at),
        variant: "text",
      },
      status: {
        data: String(item?.status || "ACTIVE").toUpperCase(),
        variant: "text",
      },
      actions: {
        data: (
          <DefaultButton
            variant="outline"
            name={deletingId === id ? "Removing..." : "Delete"}
            disabled={deletingId === id}
            onClick={() => handleDelete(item)}
          />
        ),
        variant: "text",
      },
    };
  });

  return (
    <div className="flex flex-col gap-4">
      <PageTableHeader breadcrumbs={breadcrumbs} isSearch={false} filter={false} shorting={false} />
      <div className="bg-white p-5 rounded-xl border border-borderColor">
        <CommonTable
          TableHeaderData={tableHeaders}
          tabledata={tableData}
          currentPage={currentPage}
          totalData={data.length}
          setCurrentPage={setCurrentPage}
          loading={loading}
          action={{}}
        />
      </div>
    </div>
  );
};

export default SchedulePage;
